// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NJRy","colMin":"styles_colMin__1aYE7"};